/* eslint-disable react/no-duplicate-key */
import React, { useMemo } from "react";

import {
	ActionButton,
	DropdownMenu,
	DropdownMenuContent,
	DropdownMenuItem,
	DropdownMenuTrigger
} from "../../../components";
import { MAP_LANGUAGE_CODE_LABELS } from "../../../constants";

function CodeBlockActiveButton({ action, languages, ...props }) {
	const onClick = language => {
		action(language);
	};

	const langs = useMemo(() => {
		return languages?.map(language => {
			const title = MAP_LANGUAGE_CODE_LABELS[language] || language;

			return {
				title,
				// icon: language.icon,
				language
			};
		});
	}, [languages]);

	return (
		<DropdownMenu>
			<DropdownMenuTrigger disabled={props?.disabled} asChild>
				<ActionButton
					tooltip={props?.tooltip}
					disabled={props?.disabled}
					icon={props?.icon}
				/>
			</DropdownMenuTrigger>
			<DropdownMenuContent className="richtext-w-full">
				{langs?.map(item => {
					return (
						<DropdownMenuItem
							key={`codeblock-${item.title}`}
							onClick={() => onClick(item.language)}
						>
							<div className="richtext-h-full richtext-ml-1">{item.title}</div>
						</DropdownMenuItem>
					);
				})}
			</DropdownMenuContent>
		</DropdownMenu>
	);
}

export default CodeBlockActiveButton;
